export default "__VITE_ASSET__C22cC4M$__"